import { tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { QRCodeSVG } from 'qrcode.react'
import { AmountValue, LabelValue, WarningMessage } from '../../../components'
import { CryptoPreviewTitle, CryptoPreviewWrapper } from './PreviewCrypto.styled'

export const PreviewCrypto = ({ data, onBack }) => {
  const { address, currency, tag, processingAmount } = data || {}

  return (
    <>
      <CryptoPreviewWrapper>
        <CryptoPreviewTitle>{tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.TITLE', 'Details')}</CryptoPreviewTitle>

        <LabelValue
          label={tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.ADDRESS', 'Deposit address')}
          value={address}
          enableCopy={true}
          dataTest='address'
        />

        <p className='text-center code bordered'>
          <QRCodeSVG value={address} size={150} />
        </p>

        <LabelValue
          label={tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.TAG', 'Tag')}
          value={tag}
          dataTest='tag'
          enableCopy={true}
        />

        <AmountValue amount={processingAmount} currency={currency} />

        {typeof onBack === 'function' && (
          <Button
            type='button'
            color='secondary'
            className='mt-2'
            text={tr('FRONTEND.BUTTONS.BACK', 'Back')}
            onClick={onBack}
            data-test='button-back'
          />
        )}
      </CryptoPreviewWrapper>

      <WarningMessage currency={currency} />
    </>
  )
}
